import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

// export const FilterProduct = createAsyncThunk(
//   "filterProduct/FilterProduct",
//   async (filterData, thunkAPI) => {
//     try {
//       const response = await axios.get(
//         `${endPoint.FILTERPRODUCT}?${filterData?.name}=${encodeURIComponent(
//           filterData?.Catename
//         )}`
//       );
//       return response?.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

export const FilterProduct = createAsyncThunk(
  "filterProduct/FilterProduct",
  async ({ name, Catename, page = 1, limit = 50 }, thunkAPI) => {
    try {
      const response = await axios.get(
        `${endPoint.FILTERPRODUCT}?${name}=${encodeURIComponent(Catename)}&page=${page}&limit=${limit}`
      );
      return response?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const FilterProductSlice = createSlice({
  name: "FilterProductData",
  initialState: {
    FilterProductData: [],
    currentPage: 1,
    totalPagesFilterProduct: 0,
    totalItems: 0,
    error: null,
  },
  reducers: {
    clearFilterProductData: (state) => {
      state.FilterProductData = [];
      state.currentPage = 1;
      state.totalPagesFilterProduct = 0;
      state.totalItems = 0;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(FilterProduct.fulfilled, (state, action) => {
        state.FilterProductData = action.payload || [];
        state.currentPage = action.payload?.currentPage || 1;
        state.totalPagesFilterProduct = action.payload?.totalPages || 0;
        state.totalItems = action.payload?.totalItems || 0;
      })
      .addCase(FilterProduct.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

// const FilterProductSlice = createSlice({
//   name: "FilterProductData",
//   initialState: {
//     FilterProductData: [],
//     error: null,
//   },
//   reducers: {
//     clearFilterProductData: (state) => {
//       state.FilterProductData = [];
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(FilterProduct.fulfilled, (state, action) => {
//         state.FilterProductData = action.payload;
//       })
//       .addCase(FilterProduct.rejected, (state, action) => {
//         state.error = action.payload;
//       });
//   },
// });

export const { clearFilterProductData } = FilterProductSlice.actions;
export default FilterProductSlice.reducer;
